module.exports = __webpack_public_path__ + "img/stamp_exercise_off.8a1fd1d7.svg";